import { Article } from '@wix/answers-api';

import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';
import { HttpClientFactory } from '../httpClient';

const { clientTopology } = renderModel.get();
const locale = renderModel.getLocale();

export const getArticleById = (id: string, httpClient: HttpClientFactory): Promise<Article> => {
  return httpClient
    .getInstance()
    .get(`${clientTopology.articlesUrlV2}/${id}?locale=${locale}`)
    .then((response) => response.data)
    .catch((error) => {
      logger.error({
        message: `fail to fetch Article by Id: ${id}`,
        error,
      });
      throw error;
    });
};
